import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";

// Components
import UserRouter           from "dashboard/dist/Components/UserRoute";



/**
 * Only Authenticated Users can access the given Component
 */
class UserRoute extends React.Component {
    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { isAuthenticated, ...rest } = this.props;

        return <UserRouter {...rest} isAuthenticated={isAuthenticated} />;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        isAuthenticated : PropTypes.bool.isRequired,
        isValid         : PropTypes.bool,
        isHidden        : PropTypes.bool,
        url             : PropTypes.string,
        component       : PropTypes.oneOfType([ PropTypes.func, PropTypes.object ]).isRequired,
        exact           : PropTypes.bool,
        type            : PropTypes.string,
        path            : PropTypes.string,
        location        : PropTypes.object,
        match           : PropTypes.object,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            isAuthenticated : state.auth.isAuthenticated,
        };
    }
}

export default connect(UserRoute.mapStateToProps)(UserRoute);
